export default {
      id: "saving-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#saving",
      toString: function () {
        return this.url;
      }
    }